var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconRotateDown = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(418.917 537.74)" },
                React.createElement("path", { strokeDasharray: "4,4 ", d: "M-400.7-514.6c5.1-1.8,7.7-7.4,5.9-12.4c-1.1-3.2-3.8-5.5-7-6.3" })),
            React.createElement("g", { transform: "translate(418.917 537.74)" },
                React.createElement("path", { d: "M-412.6-511.9h6.5v-6.5" }),
                React.createElement("path", { d: "M-401.8-533.3c-5.3-1.2-10.5,2.1-11.7,7.3c-0.7,3.3,0.2,6.7,2.6,9.1l4.7,5" })))));
});
export default IconRotateDown;
//# sourceMappingURL=IconRotateDown.js.map